let API_DOMAIN = null;
let EVENT_ID = null;

const winnerList = document.getElementById("winnerList");
const loadingScreen = document.getElementById("loadingScreen");

function sleep(ms) {
  return new Promise(r => setTimeout(r, ms));
}

// The API returns status as a comma-separated list of the codes that are
// currently active, e.g. "1,2,4" — several pages can be open at the same time.
function isStatusActive(status, code) {
  return String(status ?? "")
    .split(",")
    .map((s) => s.trim())
    .includes(code);
}

function showLoading(show) {
  if (!loadingScreen) return;
  loadingScreen.style.display = show ? "flex" : "none";
}

// ✅ Load config.json
async function loadConfig() {
  const res = await fetch("./config.json"); // adjust path as needed
  if (!res.ok) {
    throw new Error(`Failed to load config.json: ${res.status}`);
  }
  const config = await res.json();
  API_DOMAIN = config.apiDomain;
}

// ✅ Check event status first (same as index)
async function checkEventStatus() {
  try {
    showLoading(true);
    const res = await fetch(`${API_DOMAIN}api/event/list`);
    const data = await res.json();
    await sleep(50);

    if (data.message === "success" && Array.isArray(data.data) && data.data.length > 0) {
      const event = data.data[0];
      EVENT_ID = event.id;
      if (isStatusActive(event.status, "2")) {
        // ✅ Event is open → load winners
        await loadWinners();
      } else {
        // 🚫 Not active → go to event closed page
        window.location.href = "eventClosed.html";
      }
    } else {
      window.location.href = "eventClosed.html";
    }
  } catch (err) {
    console.error("Error checking event status:", err);
    window.location.href = "eventClosed.html";
  } finally {
    showLoading(false);
  }
}

// ✅ Load winners from API
async function loadWinners() {
  try {
    showLoading(true);
    const res = await fetch(`${API_DOMAIN}api/internal/battle/participants`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ eventId: EVENT_ID }),
    });

    const result = await res.json();
    await sleep(50);

    if (result.message === "success" && result.data?.winners?.length > 0) {
      const winners = result.data.winners;
      winnerList.innerHTML = winners
        .map(w => `<li class="player-item">${w.ticketId}</li>`)
        .join("");
    } else {
      winnerList.innerHTML = `<li class="player-item">No winners yet</li>`;
    }
  } catch (err) {
    console.error("Error fetching winners:", err);
    winnerList.innerHTML = `<li class="player-item">Error loading results</li>`;
  } finally {
    showLoading(false);
  }
}

// ✅ Init
document.addEventListener("DOMContentLoaded", async () => {
  showLoading(true);
  await sleep(50);

  try {
    await loadConfig();       // 🔹 load API_DOMAIN before anything else
    await checkEventStatus();
  } catch (err) {
    console.error("Error loading config:", err);
    window.location.href = "eventClosed.html";
  }
});